import styled from "styled-components";
import { COLORS, responsive } from "../../styles/constants.style";
import { MuiBox } from "../box/MuiBox";

export const StyledItemDetailRow = styled(MuiBox)`
  &.item-row-detail-wrapper {
    display: flex;
    align-items: flex-start;
    padding: 16px;
    border: 1px solid ${COLORS.cirrus_black3};
    border-radius: 8px;
    background-color: ${COLORS.cirrus_white};
    width: 100%;
    margin: 0 auto;
    gap: 16px;

    .line-wrapper {
      width: 2px;
      height: 48px;
      border-left: 3px solid ${COLORS.primary_light_blue2};
      border-radius: 4px;

      ${[responsive.MOBILE, responsive.TABLET_LANDSCAPE].map(
        (bp) => bp`
          height: auto;
          align-self: stretch;
        `,
      )}
    }

    .content-wrapper {
      display: flex;
      flex: 1;
      justify-content: space-between;
      flex-wrap: wrap;
      width: 100%;

      ${responsive.MOBILE`
        flex-direction: column;
        gap: 4px;
      `}
    }
    .mobile-top-row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .title-text {
        flex: 1;
        max-width: 150px;
      }
    }

    .mobile-actions {
      display: flex;
      align-items: center;
      gap: 2px;
      ${responsive.MOBILE`
        .option-menu-icon {
        padding:0px
        }
        .btn-tertiary{
        height:20px;
        }
        `}
    }

    ${responsive.MOBILE`
      .icon-text-wrapper {
        margin-left: 2px;
      }
      .status-badge-mobile-wrapper {
        margin-top: 0px;
      }
    `}

    .info-section {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      min-width: 0;
    }

    .title-text {
      color: ${COLORS.primary_light_blue};
      font-weight: 600;
      font-size: 18px;
      max-width: 400px;
    }

    .clickable {
      cursor: pointer;
    }

    .left-stack-container {
      display: flex;
      align-items: center;
      margin-top: 4px;
      gap: 8px;
      color: ${COLORS.cirrus_black7};

      ${responsive.MOBILE`
        flex-direction: column;
        gap: 4px;
        align-items: flex-start;
        .divider {
          display: none;
        }
      `};
    }

    .icon-text-wrapper {
      display: flex;
      align-items: center;
      gap: 4px;
    }

    .icon-box {
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        width: 18px;
        height: 18px;
        color: ${COLORS.cirrus_black7};
      }
    }

    .status-badge-wrapper {
      display: flex;
      align-items: center;
      height: 100%;
      min-width: 122px;
      justify-content: flex-start;
      ${responsive.MOBILE`
        min-width: 30px;
      `}
    }

    .right-section {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      gap: 16px;
      flex-wrap: wrap;

      .btn-tertiary {
        margin-left: -20px;
      }
    }
  }
`;
